module.exports = __webpack_public_path__ + "img/Medical-33-512.240c7572.png";